import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-global-loading',
    templateUrl: './global-loading.component.html',
    styleUrls: ['./global-loading.component.scss'],
    standalone: false
})
export class GlobalLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
